<template>
  <div class="home"     v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.6)">
    <div class="social_box">
      <div class="social_content">
        <div class="header" v-if="isone">
          <img
            alt
            src="https://iouke.oss-cn-beijing.aliyuncs.com/static/2020shsj/stat/beijing_banner.png"
          />
          <div class="up">
            <div class="two">
              <img
                alt
                src="https://oss2.iouke.cn/avatar/2021/2/15/d157e7937865413aaa8f10f207065df1.jpg?x-oss-process=style/avatar"
              />
              <span>中国人民大学社会实践大数数据</span>
            </div>
          </div>
        </div>
        <div class="header1" v-else>
          <img
            alt
            src="http://iouke.oss-cn-beijing.aliyuncs.com/practice/99914.png"
          />
          <div class="up">
            <div class="two" v-if="istype">
              <img v-if="logoUri" alt="加载中" :src="logoUri" />
              <span>{{ titleName }}社会实践大数据</span>
            </div>
            <div class="two" v-else>
              <img v-if="isImg" alt="加载中" :src="bannerUri" />
            </div>
          </div>
        </div>
        <div class="login_form">
          <span class="light"></span>
          <span class="light"></span>
          <span class="light"></span>
          <span class="light"></span>
          <div class="lk">
            实践足迹遍及
            <div class="nu">{{ provinceCount }}</div>
            省/地区
            <div class="nu">{{ cityCount }}</div>
            市地县
          </div>
        </div>

        <div class="map animate__animated animate__delay-1.1s">
          <div
            id="myChartChina"
            :style="{ width: '702px', height: '517px' }"
          ></div>
        </div>
      </div>
      <div class="down_box">
          <div class="down_tit">数据下载</div>
          <div :class="['down_item',{active:activeData==index}]" v-for="(item,index) in downOption" :key="index">
              <div class="tit">
                <p>{{item.title}}</p>
                <p>{{item.info}}</p>
              </div>
              <div class="download" @click="downData(index,item.title)">下载</div>
          </div>
      </div>
    </div>
    <div class="footers">
      <div class="one">
        <div class="a">
          <img
            alt
            src="http://iouke.oss-cn-beijing.aliyuncs.com/practice/aaa.svg"
          /><b>实践规模</b>
        </div>
        <div class="b_box">
          <div class="b">
            <span class="team">项目</span
            ><span class="b_a">{{ tagCount }}</span>
          </div>
          <div class="b">
            <span class="team">团队</span
            ><span class="b_a">{{ teamCount }}</span>
          </div>
          <div class="b">
            <span class="team">成员</span
            ><span class="b_a">{{ studentCount }}</span>
          </div>
        </div>
      </div>
      <div class="two">
        <div class="a">
          <img
            alt
            src="http://iouke.oss-cn-beijing.aliyuncs.com/practice/bbb.svg"
          /><b>育人成效</b>
        </div>
        <div class="b_box two_b-box">
          <div class="b">
            <div style="display: flex; align-items: center">
              <em class="iconfont iconpower"></em>
              <span class="team">{{ skillOrAb.abilityCount }}</span
              >个潜能
            </div>
            <div style="display: flex; align-items: center">
              提升均量<em class="iconfont icontisheng"></em
              >{{ skillOrAb.abilityLevelAverage | retainOne }}
            </div>
          </div>
          <div class="b">
            <div style="display: flex; align-items: center">
              <em class="iconfont iconability"></em>
              <span class="team">{{ skillOrAb.skillCount }}</span
              >个才能
            </div>
            <div style="display: flex; align-items: center">
              人均<em class="iconfont iconHCV"></em
              ><span class="team"
                >+{{ skillOrAb.skillHCVAverage | retain }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="sree">
        <div class="a">
          <img
            alt
            src="http://iouke.oss-cn-beijing.aliyuncs.com/practice/cccc.svg"
          /><b>精彩实况</b>
        </div>
        <div class="open">
          <div class="b">
            <span class="b_a" v-if="logCountHome != 0">{{
              logCountHome | userNums
            }}</span>
            <span class="b_a" v-else>{{ logCountHome }}</span>
            <span class="team">日志</span>
          </div>
          <div class="b">
            <span class="b_a" v-if="charCount != 0">{{
              charCount | userNums
            }}</span>
            <span v-else class="b_a">{{ charCount }}</span
            ><span class="team">文字</span>
          </div>
          <div class="b">
            <span class="b_a">{{ logImgNum }}</span
            ><span class="team">照片</span>
          </div>
          <div class="b">
            <span class="b_a">{{ videoNum }}</span
            ><span class="team">视频</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="form" @click="statistics" v-if="!universityId">高校统计表</div> -->
  </div>
</template>

<script>
export default {
  name: "socialPractice",
  filters: {
    userNums(num) {
      return num < 10000 ? num : (num / 10000).toFixed(1) + "W";
    },
    retain(value) {
      if (value) {
        return value.toFixed(0);
      } else {
        return 0;
      }
    },
    retainOne(value) {
      if (value) {
        return value.toFixed(1);
      } else {
        return 0;
      }
    },
    filterMoney(value) {
      if (value >= 10000) {
        return value + "万";
      }
    },
  },
  data: function () {
    return {
      isone: false,
      istype: false,
      isun: false,
      share: true,
      m: 100000000,
      show: false,
      logCountHome: "",
      charCount: 0,
      defaultWord: "",
      videoNum: 0,
      logImgNum: 0,
      active: "1",
      cityCount: "0",
      provinceCount: "0",
      cellValue: "切换数据",
      title: "数据源：北京所有院校",
      name_title: "",
      mapName: "china",
      universityCount: "0",
      memberCount: "0",
      groupCount: "0",
      characterCount: "0",
      fileCount: "0",
      imageCount: "0",
      logCount: "0",
      videoCount: "0",
      isImg: false,
      num: "",
      mapDataList: [],
      geoCoordMap: {},
      maxData: "",
      minData: "",
      id: "",
      banner: "",
      max1: 150,
      max: 2,
      skillOrAb: {},
      studentCount: 0,
      tagCount: 0,
      teamCount: 0,
      bannerUri: "",
      type1: "",
      universityId: null,
      titleName: null,
      provinceName: "",
      downOption:[{title:'支队信息',info:'各支队基本信息数据下载'},{title:'排行榜信息',info:'各支队在全省的排名汇总'},{title:'成果文件',info:'各支队上传的实践计划、结项成果文件链接汇总'},
      {title:'任务情况',info:'各支队的任务完成情况汇总'},{title:'视频列表',info:'实践日志中所含视频的链接汇总'},{title:'成员信息表',info:'各支队成员基本信息'},{title:'才能增长汇总',info:'实践日志所突显的才能增长'}
      ],
      activeData:0,
      loading:false,
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.universityId = this.$route.query.universityId;
    console.log(this.universityId);
    if (this.$route.params.share == "share") {
      this.share = false;
    }

    // this.getWeiApi();
    if (this.universityId != undefined) {
      this.getuniversityData();
      this.getUniversityLoso();
      this.getAUserStaUniversityData();
      this.getMapListStatistics();
      this.getLogLocationListUniversityData(); //头部省市数量
      this.getPPCDataUniversityData();
      this.istype = true;
    } else {
      this.getPPCData();
      this.getAUserStaData();
      this.getMapList();
      this.getLogLocationList(); //头部省市数量
      this.istype = false;
    }
  },
  components: {},
  methods: {
    downData(index,name) {
      this.activeData=index;
      this.loading=true;
      if(index==0){
         this.getManageTeamInfo();
      }else if(index==1){
         this.getManageTeamRank();
      }else if(index==2){
         this.getManageResultsAttachment();
      }else if(index==3){
        this.getManageTeamPlan();
      }else if(index==4){
        this.getManageLog();
      }else if(index==5){
         this.getManageTeamUser();
      }else if(index==6){
        this.getManageUserSkill();
      }
    },
    //下载支队信息表
    getManageTeamInfo(){
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageTeamInfo(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //下载成果
    getManageResultsAttachment(){
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageResultsAttachment(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //下载排行榜信息
    getManageTeamRank() {
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageTeamRank(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //任务情况
    getManageTeamPlan() {
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageTeamPlan(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //下载视频列表
    getManageLog() {
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageLog(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //下载成员信息表
    getManageTeamUser() {
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageTeamUser(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    //下载才能信息
    getManageUserSkill() {
      var data = {
        universityId: this.universityId,
      };
      this.$api.social.getManageUserSkill(data).then((res) => {
         window.location.href=res.data;
         this.loading=false;
      });
    },
    getUniversityLoso() {
      var data = {
        id: this.universityId,
      };
      this.$api.social.getuniversityLogo(data).then((res) => {
        this.logoUri = res.data.logoUri;
        this.titleName = res.data.name;
        this.provinceName = res.data.province;
      });
    },
    getuniversityData() {
      var data = {
        id: this.universityId,
      };
      this.$api.social.getuniversity(data).then((res) => {
        this.teamCount = res.data.teamCount; //团队
        this.studentCount = res.data.studentCount; //成员
        this.tagCount = res.data.tagCount; //专题
        this.logCountHome = res.data.logCount; //日志
        this.charCount = res.data.charCount; //文字数量
        this.logImgNum = res.data.imageCount; //图片
        this.videoNum = res.data.videoCount; //日志
      });
    },
    // statistics() {
    //   this.$router.push({
    //     path: "/form/" + this.id + "?type=" + this.id + "&type1=to",
    //   });
    // },
    getPPCDataUniversityData() {
      var data = {
        id: this.universityId,
      };
      this.$api.social.getuniversity(data).then((res) => {
        this.isImg = true;
        this.teamCount = res.data.teamCount;
        this.studentCount = res.data.studentCount;
        this.tagCount = res.data.tagCount;
        this.logCountHome = res.data.logCount;
        this.charCount = res.data.charCount;
        this.bannerUri = res.data.bannerUri;
        console.log(this.logCountHome);
      });
    },
    getPPCData() {
      var data = {
        id: this.id,
      };
      this.$api.social.getPPC(data).then((res) => {
        this.isImg = true;
        this.teamCount = res.data.teamCount;
        this.studentCount = res.data.studentCount;
        this.tagCount = res.data.tagCount;
        this.logCountHome = res.data.logCount;
        this.charCount = res.data.charCount;
        this.bannerUri = res.data.bannerUri;
        this.logImgNum = res.data.imageCount;
        this.videoNum = res.data.videoCount;
        // this.share1(res.name, this.bannerUri);
      });
    },
    getAUserStaUniversityData() {
      let _this = this;
      var data = {
        id: _this.universityId,
        // id: "D6CF5E08",
      };
      this.$api.social.getAUserStaUniversity(data).then((res) => {
        // console.log(res, 878787);
        this.skillOrAb = res.data;
      });
    },
    getAUserStaData() {
      let _this = this;
      var data = {
        id: _this.id,
        // id: "D6CF5E08",
      };
      this.$api.social.getAUserSta(data).then((res) => {
        // console.log(res, 878787);
        this.skillOrAb = res.data;
      });
    },
    getImgNumlist() {
      //获取图片总数
      let _this = this;
      var data = {
        id: _this.id,
      };
      this.$api.social.getImgNum(data).then((res) => {
        if (res.data.length != "") {
          this.logImgNum = res.data;
        }
      });
    },
    getVideoNumlist() {
      //获取视频总数
      var data = {
        id: this.id,
      };
      this.$api.social.getVideoNum(data).then((res) => {
        if (res.data.length != "") {
          this.videoNum = res.data;
        }
      });
    },
    // toshijian() {
    //   if (this.universityId == undefined) {
    //     this.$router.push({
    //       path: "/log/" + this.id,
    //     });
    //   } else {
    //     this.$router.push({
    //       path:
    //         "/log/" +
    //         this.id +
    //         "?type=" +
    //         this.id +
    //         "&type1=to&universityId=" +
    //         this.universityId,
    //     });
    //   }
    // },
    // yuren() {
    //   this.reload();
    //   if (this.universityId == undefined) {
    //     this.$router.push({
    //       path: "/flypage/" + this.id,
    //     });
    //   } else {
    //     this.$router.push({
    //       path:
    //         "/flypage/" +
    //         this.id +
    //         "?type=" +
    //         this.id +
    //         "&type1=to&universityId=" +
    //         this.universityId,
    //     });
    //   }
    // },
    // jingcai() {
    //   if (this.universityId == undefined) {
    //     this.$router.push({
    //       path: "/waterFall/" + this.id,
    //     });
    //   } else {
    //     this.$router.push({
    //       path:
    //         "/waterFall/" +
    //         this.id +
    //         "?type=" +
    //         this.id +
    //         "&type1=to&universityId=" +
    //         this.universityId,
    //     });
    //   }
    // },
    getLogLocationListUniversityData() {
      let _this = this;
      var data = {
        id: _this.universityId,
      };
      this.$api.social.getLogLocationUniversity(data).then((res) => {
        if (res.data.length != "") {
          _this.provinceCount = res.data.provinceCount;
          _this.cityCount = res.data.cityCount;
        }
      });
    },
    getLogLocationList() {
      let _this = this;
      var data = {
        id: _this.id,
      };
      this.$api.social.getLogLocation(data).then((res) => {
        console.log(res.data, 989898);
        if (res.data.length != "") {
          _this.provinceCount = res.data.provinceCount;
          _this.cityCount = res.data.cityCount;
        }
      });
    },
    getMapListStatistics() {
      let _this = this;
      // const toast = _this.$toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   className: "toast-loading",
      //   loadingType: "spinner",
      // });
      var data = {
        id: _this.universityId,
      };
      this.$api.social.getMapuniversityStatistics(data).then((res) => {
        // console.log("map", res);
        if (res.data.length != "") {
          // toast.clear();
          _this.mapDataList = res.data;
          _this.maxData = res.data[0].count;
          _this.minData = res.data[res.data.length - 1].count;
          _this.getGeoCoordMap();
          _this.drawLine();
        } else {
          _this.getGeoCoordMap();
          _this.drawLine();
        }
      });
    },
    getMapList() {
      let _this = this;
      // const toast = _this.$toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   className: "toast-loading",
      //   loadingType: "spinner",
      // });
      var data = {
        id: _this.id,
      };
      this.$api.social.getMap(data).then((res) => {
        if (res.data.length != "") {
          // toast.clear();
          _this.mapDataList = res.data;

          _this.maxData = res.data[0].count; //要排序
          _this.minData = res.data[res.data.length - 1].count;
          _this.getGeoCoordMap();
          _this.drawLine();
        } else {
          _this.getGeoCoordMap();
          _this.drawLine();
        }
      });
    },
    //获取第一排数据
    async getUserdic() {
      let _this = this;
      // const toast = _this.$toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   className: "toast-loading",
      //   loadingType: "spinner",
      // });
      var data = {
        id: _this.id,
      };
      let res = await this.$api.social.getHome(data);
      // toast.clear();
      _this.universityCount = res.data.universityCount;
      _this.memberCount = res.data.memberCount;
      _this.groupCount = res.data.groupCount;
    },
    //获取第二排数据(日志，照片、视频个数等)
    async getlogList() {
      let _this = this;
      // const toast = _this.$toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   className: "toast-loading",
      //   loadingType: "spinner",
      // });
      var data = {
        id: _this.id,
      };
      let res = await this.$api.social.getlog(data);
      // toast.clear();
      _this.fileCount = res.data.fileCount;
      _this.imageCount = res.data.imageCount;
      _this.logCount = res.data.logCount;
      _this.videoCount = res.data.videoCount;
      if (res.data.characterCount < 10000) {
        _this.characterCount = res.data.characterCount;
      } else {
        _this.characterCount = (
          Math.round((res.data.characterCount / 10000) * 100) / 100
        ).toFixed(1);
        _this.characterCount = _this.characterCount + "万";
      }
    },

    onSelect(item) {
      this.show = false;
      this.title = "数据源：" + item.name;
    },

    getGeoCoordMap() {
      var that = this;
      var mapFeatures = that.mapDataList;
      mapFeatures.forEach(function (v) {
        // 地区名称
        var name = v.city;
        var arry = [];
        // 地区经纬度
        arry.push(v.latitude);
        arry.unshift(v.longitude);
        that.geoCoordMap[name] = arry;
      });
    },
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].city];
        if (geoCoord) {
          res.push({
            name: data[i].city,
            value: geoCoord.concat(data[i].count),
          });
        }
      }
      return res;
    },
    drawLine() {
      var that = this;
      var myChartContainer = document.getElementById("myChartChina");
      var myChartChina = that.$echarts.init(myChartContainer);
      // 绘制图表
      var optionMap = {
        title: {
          text: "",
          left: "center",
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + " : " + params.value[2];
          },
        },
        geo: {
          map: "china",
          label: {
            emphasis: {
              show: false,
            },
          },
          roam: false, //控制是否移动
          itemStyle: {
            normal: {
              areaColor: "rgb(70, 130, 180)",
              borderColor: "rgb(9, 54, 95)",
            },
            emphasis: {
              areaColor: "rgb(10, 105, 187)",
            },
          },
        },
        series: [
          {
            name: "散点测试",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: that.convertData(that.mapDataList),
            symbolSize: function (val) {
              // console.log(1111, val);
              var data =
                ((10 - 1.5) * (val[2] - that.minData)) /
                  (that.maxData - that.minData) +
                1.5;
              // console.log(that.maxData, that.minData, val[2], data);
              return data;
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: "#DA29C1",
                shadowBlur: 10,
                shadowColor: "yellow",
              },
              emphasis: {
                borderColor: "#fff",
                borderWidth: 1,
              },
            },
          },
          {
            type: "map",
            map: "china",
            geoIndex: 0,
            aspectScale: 1,
            tooltip: {
              show: false,
            },
          },
        ],
      };
      myChartChina.setOption(optionMap);
      window.onresize = function () {
        myChartChina.resize();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  padding-bottom: 80px;
  .social_box{
    width: 1600px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px auto;
    height: 872px;
    .down_box{
      width: 506px;
      background: #fff;
      border-radius: 20px;
      height: 100%;
      padding: 30px 20px;
      .down_tit{
        font-size: 20px;
        font-weight: bold;
        color: #000;
        margin-bottom: 12px;
      }
      .down_item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 92px;
        width: 100%;
        border:4px solid #F5F6FD;
        border-radius: 20px;
        padding: 16px;
        margin-bottom: 18px;
        .tit{
          p:nth-child(1){
            font-size: 18px;
            color: #2A2E3D;
            margin-bottom: 10px;
          }
          p:nth-child(2){
            font-size: 14px;
            color: #7C829D;
          }
        }
        .download{
          width: 90px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          color: #007F41;
          border-radius: 15px;
          font-size: 16px;
          border:1px solid #007F41;
          cursor: pointer;
        }
      }
      .active{
        border:4px solid rgba(0,127,65,.1);
        .tit{
          p:nth-child(1){
            color: #007F41;
          }
        }
      }
    }
  }
  .social_content {
    width: 1062px;
    background: #fff;
    border-radius: 20px;
    position: relative;
     height: 872px;
  }
  .header {
    width: 100%;
    max-width: 640px;
    height: 125px;
    img {
      width: 100%;
      opacity: 0.3;
      margin-top: -15px;
    }
    .up {
      height: 124px;
      width: 100%;
      // max-width: 640px;
      background: rgba(27, 27, 67, 0.5);
      position: absolute;
      top: 80px;
      box-shadow: 0px 1px 15px rgba(0, 255, 255, 25%);
      border-radius: 0 0 20px 20px;

      .one {
        width: 70px;
        height: 30px;
        background: #404061;
        border-radius: 50px;
        color: #fff;
        position: absolute;
        right: 20px;
        top: 15px;
        text-align: center;
        line-height: 30px;
        font-size: 13px;
        em {
          font-size: 12px;
          margin-left: 4px;
        }
      }
      .two {
        position: relative;
        margin-top: 67px;
        z-index: 999;
        display: flex;
        width: 90%;
        margin-left: 5%;
        img {
          width: 50px;
          height: 50px;
          border-radius: 100px;
          opacity: 1;
          margin-right: 15px;
        }
        span {
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
  .header1 {
    width: 100%;
    height: 125px;
    max-width: 640px;
    img {
      // width: 100%;

      // margin-top: -15px;
    }
    .up {
      height: 100px;
      // max-width: 640px;
      width: 970px;
      left: 50%;
      margin-left: -485px;
      background: #f5f6fd;
      position: absolute;
      top: 40px;
      box-shadow: 0px 1px 15px rgba(0, 255, 255, 25%);
      border-radius: 0 0 20px 20px;
      .share {
        width: 70px;
        height: 30px;
        background: #404061;
        border-radius: 50px;
        color: #fff;
        position: absolute;
        right: 20px;
        top: 15px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        em {
          font-size: 13px;
          margin-right: 4px;
        }
      }
      .ones {
        width: 70px;
        height: 30px;
        // background: #404061;
        border-radius: 50px;
        color: #fff;
        position: absolute;
        // left: 20px;
        top: 15px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        em {
          font-size: 13px;
          margin-right: 4px;
        }
      }
      .one {
        width: 70px;
        height: 30px;
        background: #404061;
        border-radius: 50px;
        color: #fff;
        position: absolute;
        right: 20px;
        top: 15px;
        text-align: center;
        line-height: 30px;
        font-size: 13px;
        em {
          font-size: 11px;
          margin-left: 4px;
        }
      }
      .two {
        position: relative;
        z-index: 999;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        height: 100%;
        img {
          // width: 90%;
          height: 60px;
          border-radius: 100px;
          opacity: 1;
          margin-right: 15px;
          object-fit: contain;
          object-position: left;
        }
        span {
          color: #2a2e3d;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .login_form {
    position: absolute;
    top: 230px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 330px;
    height: 53px;
    background: #ffffff;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 0 10px 20px rgb(0, 127, 65, 0.24);
    border: 1px solid #2a3cad;
    color: white;
    padding: 20px;
    border: 1px solid rgba(0, 127, 65, 0.3);
    line-height: 53px;
    border-radius: 6px;
    text-align: center;
    .light {
      position: absolute;
      display: block;
    }
    .light:nth-child(1) {
      filter: hue-rotate(0deg);
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgb(0, 127, 65));
      animation: animate1 8s linear infinite;
    }
    @keyframes animate1 {
      0% {
        left: -100%;
      }

      50%,
      100% {
        left: 100%;
      }
    }
    .light:nth-child(2) {
      filter: hue-rotate(60deg);
      top: -100%;
      right: 0;
      width: 1px;
      height: 100%;
      background: linear-gradient(180deg, transparent, #7af0ec);
      animation: animate2 8s linear infinite;
      animation-delay: 2s;
    }

    @keyframes animate2 {
      0% {
        top: -100%;
      }

      50%,
      100% {
        top: 100%;
      }
    }
    .light:nth-child(3) {
      filter: hue-rotate(120deg);
      bottom: 0;
      right: 0;
      width: 100%;
      background: linear-gradient(270deg, transparent, #7af0ec);
      animation: animate3 8s linear infinite;
      animation-delay: 4s;
    }

    @keyframes animate3 {
      0% {
        right: -100%;
        height: 1px;
      }

      50%,
      100% {
        height: 1px;
        right: 100%;
      }
    }
    .light:nth-child(4) {
      filter: hue-rotate(300deg);
      bottom: -100%;
      left: 0;
      width: 1px;
      height: 100%;
      background: linear-gradient(360deg, transparent, #7af0ec);
      animation: animate4 8s linear infinite;
      animation-delay: 6s;
    }

    @keyframes animate4 {
      0% {
        bottom: -100%;
      }

      50%,
      100% {
        bottom: 100%;
      }
    }
  }
  .box {
    position: absolute;
    top: 26%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 330px;
    height: 53px;
    background: #111845a6;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 0 20px 50px rgb(23, 32, 90);
    border: 2px solid #2a3cad;
    color: white;
    padding: 20px;
    border: 2px solid rgba(119, 237, 235, 0.3);
    line-height: 53px;

    .nu {
      font-size: 22px;
      // padding: 0 11px;
    }
  }

  .box span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
  }
  .lk {
    position: relative;
    margin-top: -21px;
    height: 50px;
    display: flex;
    color: #7c829d;
    font-size: 14px;
    justify-content: center;
    .nu {
      margin: 0 5px;
      color: #007F41;
      font-size: 29px;
      font-weight: bold;
    }
  }
  .box span:nth-child(1) {
    transform: rotate(0deg);
  }

  .box span:nth-child(2) {
    transform: rotate(90deg);
    left: 83.8%;
    height: 53px !important;
    width: 53px !important;
  }

  .box span:nth-child(3) {
    transform: rotate(180deg);
  }

  .box span:nth-child(4) {
    transform: rotate(270deg);
    left: 0%;
    height: 53px !important;
    width: 53px !important;
  }

  .box span:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    // background: #50dfdb;
    background: linear-gradient(to right, #d6dcdc, #7af0ec) !important;
    animation: animate 3s linear infinite;
    border-radius: 100px;
  }

  .top {
    width: 100%;
    .topLeft {
      float: left;
      margin-top: -5px;
    }
    .topRight {
      margin-top: 30px;
      float: left;
      width: 85%;
      text-align: center;
    }
    .line {
      border-top: 1px solid #ffffff;
      width: 90%;
      height: auto;
      float: left;
      margin-left: 5%;
      margin-top: 5px;
      opacity: 0.5;
    }
  }
  .center {
    width: 90%;
    max-width: 570px;
    left: 5%;
    background: #2b3b54;
    max-width: 640px;
    border-radius: 3px;
    float: left;
    height: 190px;
    margin-top: 20px;
    position: absolute;
    .lineauto {
      border-top: 1px solid #fff;
      opacity: 0.5;
      width: 90%;
      margin-left: 5%;
    }
    .van-row {
      padding: 20px 0%;
      .van-col {
        text-align: center;
        height: 60px;
        display: grid;
        line-height: 31px;
        border-right: 1px solid #888;
        color: #fff;
        .essay {
          b {
            font-size: 0.2rem;
            margin-left: 3px;
          }
        }
        .num {
          font-size: 0.5rem;
          color: #fff;
          text-align: center;
          b {
            font-size: 0.2rem;
            margin-left: 3px;
          }
        }
        .title {
          font-size: 0.25rem;
          color: #fff;
          float: left;
          text-align: center;
          opacity: 0.5;
        }
        .col_right {
          font-size: 0.25rem;
          text-align: left;
          .team {
            opacity: 0.5;
            float: left;
            padding: 0 6px 0 13px;
          }
          .num {
            font-size: 0.25rem;
            position: absolute;
          }
        }
      }
    }
    .van-col:nth-child(3) {
      border: none;
    }
  }
  .form {
    width: 92%;
    margin-left: 4%;
    color: #ffffff;
    opacity: 0.5;
    /* height: 150px; */
    max-width: 530px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    -ms-flex-pack: distribute;
    font-size: 11px;
    justify-content: space-around;
    margin-bottom: 80px;
  }
  .footers {
    width: 1618px;
    margin: 0 auto;
    height: 138px;
    display: flex;
    justify-content: space-between;
    bottom: 40px;
    .b_box {
      display: flex;
      align-items: center;
    }
    .one {
      width: 32%;
      background: #fff;
      box-shadow: 0px 0px 20px rgba(208, 210, 219, 0.6) inset;
      border-radius: 5px;
      height: 138px;
      padding: 14px 21px;
      .a {
        width: 100%;
        font-size: 18px;
        color: #2a2e3d;
        display: flex;
        height: 38px;
        align-items: center;
        /* align-items: center; */
        /* align-content: center; */
        text-align: center;
        justify-content: flex-start;
        padding-top: 8px;
        img {
          margin-left: -2px;
          margin-top: 7px;
          width: 35px;
          height: 35px;
        }
        b {
          margin-left: -2px;
        }
      }
      .b {
        font-size: 13px;
        color: #7c829d;
        padding: 25px 10px 0 20px;
        .b_a {
          color: #fb71fd;
          margin-left: 11px;
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
    .two {
      width: 32%;
      background: #fff;
      height: 138px;
      box-shadow: 0px 0px 20px rgba(208, 210, 219, 0.6) inset;
      border-radius: 5px;
      padding: 14px 21px;
      .a {
        width: 100%;
        font-size: 18px;
        color: #2a2e3d;
        display: flex;
        align-items: center;
        /* align-items: center; */
        /* align-content: center; */
        height: 38px;
        text-align: center;
        justify-content: flex-start;
        padding-top: 8px;
        img {
          margin-left: -2px;
          margin-top: 7px;
          width: 35px;
          height: 35px;
        }
        b {
          margin-left: -2px;
        }
      }
      .b {
        font-size: 13px;
        color: #fff;
        padding: 15px 10px 0 10px;
        color: #7c829d;
        margin-right: 55px;
        line-height: 25px;
        em {
          color: #7c829d;
          font-size: 12px;
        }
        em.iconfont.icontisheng {
          font-size: 12px;
          color: #007F41;
          margin: 0 3px;
        }
        em.iconfont.iconHCV {
          font-size: 12px;
          color: #7c829d;
          margin: 0 1px;
        }

        .team {
          color: #007F41;
          font-size: 13px;
          margin: 0 3px;
          font-size: 15px;
          font-weight: bold;
        }
        .b_a {
          color: #fb71fd;
          margin-left: 7px;
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
    .sree {
      width: 32%;
      background: #fff;
      height: 138px;
      box-shadow: 0px 0px 20px rgba(208, 210, 219, 0.6) inset;
      border-radius: 5px;
      display: inline-table;
      padding: 14px 21px;
      .a {
        width: 100%;
        font-size: 18px;
        color: #2a2e3d;
        display: flex;
        height: 38px;
        align-items: center;
        text-align: center;
        justify-content: flex-start;
        padding-top: 8px;
        padding-bottom: 5px;

        img {
          margin-left: -2px;
          margin-top: 7px;
          width: 35px;
          height: 35px;
        }
        b {
          margin-left: -2px;
        }
      }
      .open {
        padding: 0 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .b {
          font-size: 13px;
          color: #7c829d;
          padding: 15px 10px 0 20px;
          align-items: flex-end;
          align-items: center;
          display: inline-flex;
          flex-direction: column;
          .b_a {
            color: #6ba2f2;
            text-align: center;
            font-size: 15px;
            font-weight: bold;
          }
          .team {
            margin-top: 6px;
          }
        }
      }
    }
  }
  .map {
    margin: 0 auto;
    margin-top: 150px;
    display: flex;
    justify-content: center;
    .maptoggle {
      .van-action-sheet {
        height: 30%;
      }
      .van-action-sheet__cancel {
        position: fixed;
        bottom: 0;
        background: #eee;
      }
      .van-cell {
        background: transparent;
        color: rgba(255, 255, 255, 0.5);
        opacity: 0.8;
        border: none;
        padding-left: 20px;
        .van-cell__value {
          color: #fb3b00;
        }
        .van-cell__right-icon {
          color: #fb3b00;
        }
      }
      .van-cell::after {
        border: none;
      }
    }
  }
}
@media screen and (max-device-width: 375px) {
  .home .center {
    height: 160px;
  }
  .home .center .van-row {
    padding: 10px 0%;
  }
  .map {
    margin-top: 100px !important;
  }
}
@media screen and (max-device-height: 667px) {
  .home .center {
    height: 160px;
  }
  .home .center .van-row {
    padding: 10px 0%;
  }
  .map {
    margin-top: 70px !important;
  }
}
@media screen and (max-device-height: 812px) {
  .home .center {
    height: 160px;
  }
  .home .center .van-row {
    padding: 10px 0%;
  }
  .map {
    margin-top: 110px;
  }
}
.container {
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  background-color: #111845;
}

.background-img {
  height: 400px;
  width: 800px;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5% auto;
  padding: 20px;
  border: 1px solid #2a3cad;
  border-radius: 4px;
  box-shadow: 0px 0px 5px #2a3cad;
  position: relative;
}

.content h2 {
  font-size: 19px;
}

@keyframes animate {
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }
  50% {
    transform: scaleX(1);
    transform-origin: left;
  }
  50.1% {
    transform: scaleX(1);
    transform-origin: right;
  }

  100% {
    transform: scaleX(0);
    transform-origin: right;
  }
}
.two_b-box {
  justify-content: space-between;
}
.downData {
  background-color: #007F41;
  font-size: 16px;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  position: absolute;
  bottom: 30px;
  right: 30px;
  a {
    color: #fff;
  }
}
</style>

